<div
  class="header-item h-100 d-flex flex-column align-items-center justify-content-center px-4"
  [class.selected]="item.selected"
  (click)="!item.selected && onClick()"
>
  <digital-platform-icon
    [icon]="icon"
    class="pillar-icon mx-3"
    [height]="24"
    [width]="24"
  ></digital-platform-icon>
  <div class="name">
    {{ item.name }}
  </div>
</div>
